export interface IOpenNewTicketRequest  {
    DepartmentID: number;
    Message: string;
    Subject: string;
    Name: string;
    Email: string;
    UserID: number;
    Priority: string;
    Admin: boolean;
    Status: string;
    AdminID: number;
}

export class OpenNewTicketRequest  implements IOpenNewTicketRequest {
    DepartmentID: number;
    Message: string;
    Subject: string;
    Name: string;
    Email: string;
    UserID: number;
    Priority: string;
    Admin: boolean;
    Status: string;
    AdminID: number;

}
